import React from 'react';
import './LoadingSkeleton.css';

const LoadingSkeleton = () => {
  return (
    <div className="loading-skeleton-container">


      {/* Stats Cards Skeleton */}
      <div className="skeleton-stats-container">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="skeleton-stat-card">
            <div className="skeleton-stat-icon" />
            <div className="skeleton-stat-content">
              <div className="skeleton-stat-value" />
              <div className="skeleton-stat-label" />
            </div>
          </div>
        ))}
      </div>

      {/* Meeting List Header Skeleton */}
      <div className="skeleton-list-header">
        <div className="skeleton-list-header-content">
          <div className="skeleton-list-title" />
          <div className="skeleton-list-subtitle" />
        </div>
        <div className="skeleton-refresh-button" />
      </div>

      {/* Meeting Cards Grid Skeleton */}
      <div className="skeleton-meetings-grid">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="skeleton-meeting-card">
            {/* Card Header */}
            <div className="skeleton-meeting-header">
              <div className="skeleton-meeting-title" />
              <div className="skeleton-status-badge" />
            </div>

            {/* Meeting Description */}
            <div className="skeleton-meeting-description" />
            
            {/* Meeting Info Rows */}
            <div className="skeleton-meeting-info">
              <div className="skeleton-info-row">
                <div className="skeleton-info-icon" />
                <div className="skeleton-info-text">
                  <div className="skeleton-info-primary" />
                  <div className="skeleton-info-secondary" />
                </div>
              </div>
              
              <div className="skeleton-info-row">
                <div className="skeleton-info-icon" />
                <div className="skeleton-info-text">
                  <div className="skeleton-info-primary" />
                </div>
              </div>

              {/* Meeting ID Box */}
              <div className="skeleton-meeting-id">
                <div className="skeleton-id-label" />
                <div className="skeleton-id-value" />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="skeleton-meeting-actions">
              <div className="skeleton-join-button" />
              <div className="skeleton-action-buttons">
                <div className="skeleton-action-btn" />
                <div className="skeleton-action-btn" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;